// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* El contenedor de la galería ocupa el 100% del ancho */
.netflix-gallery {
  margin: 0 auto;
  padding: 20px;
}

.gallery-header {
  text-align: left;
  margin-bottom: 20px;
  margin-left: 80px;
}

.gallery-title {
  font-size: 69px;
  color: #000000;
  font-family: "CreatoDisplay", sans-serif;
  font-weight: 800;
  text-transform: uppercase;
}

.gallery-subtitle {
  font-family: "EB Garamond", "EB Garamond Placeholder", serif;
  font-size: 24px;
  font-style: italic;
  margin-right: 10px;
  color: #181818;
  font-weight: 100;
}
.gallery-text {
  font-family: "CreatoDisplay", sans-serif;
  font-size: 18px;
  color: #181818;
  font-weight: 500;
  margin-right: 300px;
}

.agency-title {
  font-family: "CreatoDisplay", sans-serif;
  font-size: 36px; /* Ajusta el tamaño según lo necesites */
  font-weight: 800; /* Asegura que sea legible y destaque */
  font-style: normal; /* Quita la cursiva */
  text-transform: uppercase;
  color: #000000;
  margin-right: 5px;
}

.brands-gallery {
  width: 100%;
  height: 100%; /* Ajusta esta altura según sea necesario */
  position: relative;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
}

/* Estilos de las imágenes de la galería */
.brand-img {
  transition: transform 0.3s ease, opacity 0.3s ease;
  cursor: pointer;
  position: relative;
  opacity: 1; /* Cambiado a 1 para quitar el efecto gris */
}

.hipervinculo {
  text-decoration: none;
  color: #393939;
}
/* Variaciones en tamaños y posiciones */
.img-0 {
  width: 30%;
  margin: 10px;
}

.img-1 {
  width: 40%;
  margin: 10px;
}

.img-2 {
  width: 35%;
  margin: 10px;
}

.img-3 {
  width: 45%;
  margin: 10px;
}

.img-4 {
  width: 38%;
  margin: 10px;
}

/* Estilos para el zoom cuando se hace clic en la imagen */
.zoom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
}

.zoomed-img {
  max-width: 90%;
  max-height: 90%;
  transition: transform 0.3s ease;
}

.zoomed-img:hover {
  transform: scale(1.05);
}
@media (max-width: 768px) {
  .gallery-header {
    margin-left: 0.5cm;
  }
  .gallery-title {
      font-size: 45px; /* Smaller font size */
      align-items: left;
  }
  .agency-title {
    font-size: 32px; /* Ajusta el tamaño según lo necesites */
  }
  .gallery-subtitle {
    font-size: 18px; /* Ajusta el tamaño según lo necesites */
  }
  
  .gallery-text {
    font-size: 15px;
    margin-right: 0px;
  }
  .brands-gallery {
    display: flex;
    flex-direction: column; /* Alinear las imágenes en una columna */
    align-items: center; /* Centrar las imágenes en el contenedor */
  }

  /* Ajustar las imágenes para que ocupen el 100% del contenedor en móviles */
  .brand-img, .img-0, .img-1, .img-2, .img-3, .img-4, .img-5, .img-6, .img-7, .img-8, .img-9, .img-10 {
    width: 100%; /* Hacer que cada imagen ocupe el 100% del ancho disponible */
    margin: 10px 0; /* Agregar margen solo en la parte superior e inferior */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Brands-p.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,eAAe,EAAE,wCAAwC;EACzD,gBAAgB,EAAE,uCAAuC;EACzD,kBAAkB,EAAE,qBAAqB;EACzC,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,2CAA2C;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,kDAAkD;EAClD,eAAe;EACf,kBAAkB;EAClB,UAAU,EAAE,4CAA4C;AAC1D;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA,wCAAwC;AACxC;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;MACI,eAAe,EAAE,sBAAsB;MACvC,iBAAiB;EACrB;EACA;IACE,eAAe,EAAE,wCAAwC;EAC3D;EACA;IACE,eAAe,EAAE,wCAAwC;EAC3D;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB,EAAE,wCAAwC;IAChE,mBAAmB,EAAE,0CAA0C;EACjE;;EAEA,2EAA2E;EAC3E;IACE,WAAW,EAAE,6DAA6D;IAC1E,cAAc,EAAE,wDAAwD;EAC1E;AACF","sourcesContent":["/* El contenedor de la galería ocupa el 100% del ancho */\n.netflix-gallery {\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.gallery-header {\n  text-align: left;\n  margin-bottom: 20px;\n  margin-left: 80px;\n}\n\n.gallery-title {\n  font-size: 69px;\n  color: #000000;\n  font-family: \"CreatoDisplay\", sans-serif;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.gallery-subtitle {\n  font-family: \"EB Garamond\", \"EB Garamond Placeholder\", serif;\n  font-size: 24px;\n  font-style: italic;\n  margin-right: 10px;\n  color: #181818;\n  font-weight: 100;\n}\n.gallery-text {\n  font-family: \"CreatoDisplay\", sans-serif;\n  font-size: 18px;\n  color: #181818;\n  font-weight: 500;\n  margin-right: 300px;\n}\n\n.agency-title {\n  font-family: \"CreatoDisplay\", sans-serif;\n  font-size: 36px; /* Ajusta el tamaño según lo necesites */\n  font-weight: 800; /* Asegura que sea legible y destaque */\n  font-style: normal; /* Quita la cursiva */\n  text-transform: uppercase;\n  color: #000000;\n  margin-right: 5px;\n}\n\n.brands-gallery {\n  width: 100%;\n  height: 100%; /* Ajusta esta altura según sea necesario */\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: center;\n}\n\n/* Estilos de las imágenes de la galería */\n.brand-img {\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  opacity: 1; /* Cambiado a 1 para quitar el efecto gris */\n}\n\n.hipervinculo {\n  text-decoration: none;\n  color: #393939;\n}\n/* Variaciones en tamaños y posiciones */\n.img-0 {\n  width: 30%;\n  margin: 10px;\n}\n\n.img-1 {\n  width: 40%;\n  margin: 10px;\n}\n\n.img-2 {\n  width: 35%;\n  margin: 10px;\n}\n\n.img-3 {\n  width: 45%;\n  margin: 10px;\n}\n\n.img-4 {\n  width: 38%;\n  margin: 10px;\n}\n\n/* Estilos para el zoom cuando se hace clic en la imagen */\n.zoom-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 1000;\n}\n\n.zoomed-img {\n  max-width: 90%;\n  max-height: 90%;\n  transition: transform 0.3s ease;\n}\n\n.zoomed-img:hover {\n  transform: scale(1.05);\n}\n@media (max-width: 768px) {\n  .gallery-header {\n    margin-left: 0.5cm;\n  }\n  .gallery-title {\n      font-size: 45px; /* Smaller font size */\n      align-items: left;\n  }\n  .agency-title {\n    font-size: 32px; /* Ajusta el tamaño según lo necesites */\n  }\n  .gallery-subtitle {\n    font-size: 18px; /* Ajusta el tamaño según lo necesites */\n  }\n  \n  .gallery-text {\n    font-size: 15px;\n    margin-right: 0px;\n  }\n  .brands-gallery {\n    display: flex;\n    flex-direction: column; /* Alinear las imágenes en una columna */\n    align-items: center; /* Centrar las imágenes en el contenedor */\n  }\n\n  /* Ajustar las imágenes para que ocupen el 100% del contenedor en móviles */\n  .brand-img, .img-0, .img-1, .img-2, .img-3, .img-4, .img-5, .img-6, .img-7, .img-8, .img-9, .img-10 {\n    width: 100%; /* Hacer que cada imagen ocupe el 100% del ancho disponible */\n    margin: 10px 0; /* Agregar margen solo en la parte superior e inferior */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
